export const mapKey = (key: string): string => {
  if (key === ' ') {
    return 'Space';
  }
  if (/^\d$/.test(key)) {
    return `Digit${key}`;
  }
  if (key.length === 1) {
    return key.toUpperCase();
  }

  return key;
};
